import { useCallback, useMemo } from "react";
import { KPI_CODES } from "../../../kpiCodes";
import dayjs from "../../../../../configs/dayjs";
import { useXAxisFormat } from "../../../hooks/useXAxisFormat";
import { useFetchDataForTwoLines } from "../../../hooks/useFetchDataForTwoLines";

export const useFetchData = (granularity: number, isRecalculated: boolean) => {
  const { xAxisFormat, tooltipFormat } = useXAxisFormat(granularity);

  const kpiCodes = useMemo(() => {
    if (granularity === 1) {
      return [KPI_CODES.MAILING_EMAILS_TODAY, KPI_CODES.MAILING_LETTERS_TODAY];
    } else if (granularity === 2) {
      return [
        KPI_CODES.MAILING_EMAILS_THIS_MONTH,
        KPI_CODES.MAILING_LETTERS_THIS_MONTH,
      ];
    }

    return [
      KPI_CODES.MAILING_EMAILS_THIS_YEAR,
      KPI_CODES.MAILING_LETTERS_THIS_YEAR,
    ];
  }, [granularity]);

  const getFormattedItem = useCallback(
    (item: any, kpi: any) => {
      const type: string = item.code.split(".")[1];

      return {
        month: dayjs(kpi.createdAt).format(xAxisFormat),
        type,
        value: kpi.value,
        tooltipValue: dayjs(kpi.createdAt).format(tooltipFormat),
        isMain: type === "Emails",
      };
    },
    [tooltipFormat, xAxisFormat],
  );

  const { data, isLoading } = useFetchDataForTwoLines(
    granularity,
    isRecalculated,
    kpiCodes,
    getFormattedItem,
  );

  return { data, isLoading };
};
